module.exports = __webpack_public_path__ + "static/media/bn_4.de62fe78.png";